var next = __webpack_require__.x;
__webpack_require__.x = () => {
	return Promise.all([
		__webpack_require__.e(7846),
		__webpack_require__.e(7400)
	]).then(next);
};